import 'intersection-observer';
import './teaserList.html.twig';
import './teaserList.css';

export default function() {
  const el = document.querySelectorAll('.teaser-list');

  if (!el) {
    return;
  }

  [...el].forEach(teaserList => {
    const root = teaserList.querySelector('.teaser-list__row--carousel');

    const indicator = teaserList.querySelector('.teaser-list__indicator-container');
    const elements = [...teaserList.querySelectorAll('.teaser-list__row--carousel > *')];

    const observer = new IntersectionObserver(
      entries => {
        const activated = entries.reduce((max, entry) =>
          entry.intersectionRatio > max.intersectionRatio ? entry : max
        );

        if (activated.isIntersecting) {
          renderIndicator(
            indicator,
            elements,
            elements.findIndex(e => e === activated.target)
          );
        }
      },
      {
        root,
        threshold: 0.8,
      }
    );

    observer.POLL_INTERVAL = 100;
    elements.forEach(e => observer.observe(e));
  });

  function renderIndicator(indicator, elements, activeElement) {
    indicator.innerHTML = '';
    for (let i = 0; i < elements.length; i++) {
      const button = document.createElement('button');
      button.classList.add('teaser-list__indicator');
      if (i === activeElement) {
        button.classList.add('teaser-list__indicator--active');
      }

      indicator.appendChild(button);
    }
  }
}
